(function() { window.GUID_5bb8e0f3_416c_4542_a1e2_5175db0eccd8 = { getGuid: function() { return "5bb8e0f3-416c-4542-a1e2-5175db0eccd8"; } }; })();
var CS;
(function (CS) {
    class Page {
        constructor() {
            this.OnPageInstantiated();
        }
    }
    CS.Page = Page;
})(CS || (CS = {}));

//# sourceMappingURL=page.js.map
